import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useExerciseEditFormPagesRedirect = () => {
  return usePagesRedirect('useExerciseEditFormPagesRedirect');
};
